import jQuery from 'jquery'
import jQueryUjs from 'jquery-ujs'

window.$ = jQuery
window.jQuery = jQuery

jQueryUjs(jQuery)
